/* Basics · header que se esconde al bajar y vuelve al subir. Ver assets/bn-header.css.
   - No se esconde en los primeros 200 px ni con el menú o un panel abierto.
   - Tolerancia de 8 px: el temblor del trackpad no lo hace titilar. */
(function () {
  var html = document.documentElement, body = document.body;
  if (!body || body.classList.contains('template-product')) return;
  var ab = document.querySelector('.shopify-section-announcement-bar'), hd = document.querySelector('.shopify-section-header');
  // --bn-ab: alto de la barra de anuncios; --bn-hdr: anuncios + header (lo usan los accesos fijos de la colección)
  var medir = function () {
    var a = ab ? ab.offsetHeight : 0;
    html.style.setProperty('--bn-ab', a + 'px');
    html.style.setProperty('--bn-hdr', a + (hd ? hd.offsetHeight : 0) + 'px');
  };
  medir(); addEventListener('resize', medir);
  var ultimo = scrollY, oculto = false, TOL = 8, ZONA = 200;
  var abierto = function () {
    return /menu-mobile--open|overflow-hidden/.test(body.className) ||
      !!document.querySelector('.shopify-section-header details[open]');
  };
  var poner = function (v) { if (v !== oculto) { oculto = v; html.classList.toggle('bn-hdr-oculto', v); } };
  addEventListener('scroll', function () {
    var y = scrollY, d = y - ultimo;
    if (y < ZONA || abierto()) { poner(false); ultimo = y; return; }
    if (Math.abs(d) < TOL) return;
    poner(d > 0); ultimo = y;
  }, { passive: true });
})();
